const routes = [
  {
    path: "/perfis",
    name: "perfil-list",
    meta: {
      allowedPermissions: ["perfil_list"],
    },
    component: () => import("@/views/Perfil/ListView.vue"),
  },
  {
    path: "/perfis/novo",
    name: "perfil-add",
    meta: {
      allowedPermissions: ["perfil_insert"],
    },
    component: () => import("@/views/Perfil/AddView.vue"),
  },
  {
    path: "/perfis/:id/editar",
    name: "perfil-edit",
    meta: {
      allowedPermissions: ["perfil_update"],
    },
    component: () => import("@/views/Perfil/EditView.vue"),
  },
  {
    path: "/perfis/:id/permissoes",
    name: "perfil-permissoes",
    meta: {
      allowedPermissions: ["perfil_permissao_update"],
    },
    component: () => import("@/views/Perfil/PermissionView.vue"),
  },
  {
    path: "/perfis/:id/copiar_perfil",
    name: "copiar-perfil",
    meta: {
      allowedPermissions: ["perfil_update"],
    },
    component: () => import("@/views/Perfil/CopiarView.vue"),
  },
];

export default routes;
